import "./LoginPage.scss"
import LoginForm from './components/login-form/LoginForm';
import { ReactComponent as JCRLogo } from "../../assets/jcr-logo.svg";
function LoginPage() {

  return (
    <div className='LoginPage min-h-screen w-screen flex flex-column align-items-center justify-content-start'>
      <header className='w-full pt-6 px-6'>
        <JCRLogo className="JCRLogo" />
      </header>
      <div className="flex align-items-center justify-content-center w-full flex-grow-1">
        <div className='w-full mx-6 md:w-5'>
          <LoginForm />
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
